import logo from "./logo/scienoAcademy_logo_b.svg"
import logoW from "./logo/scienoAcademy_logo_w.svg"
import logoBanner from "./logo/scienoAcademy_banner.png"

export const Images = {
    logo,
    logoW,
    logoBanner
}